import * as React from 'react';

const ButtonDropdownGridCell = ({ className , children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        role: "gridcell"
    }, children);
};

export { ButtonDropdownGridCell };
//# sourceMappingURL=ButtonDropdownGridCell.js.map
